import React, { useEffect, useState } from "react";
import { InfoHeader } from "../../../customComponent/InfoHeader";
import { Box, FormLabel, Grid, Typography } from "@mui/material";
import { MainContainer } from "../../../content/content.element";
import InputField, {
  SelectInputField,
} from "../../../customComponent/InputField";
import { SubmitButton, SwitchButton } from "../../../customComponent/Buttons";
import { useNavigate } from "react-router-dom";
import TopicUploadComponent from "../../../customComponent/TopicUploadComponent";
import { useDispatch, useSelector } from "react-redux";
import { ieltsCategoryFindAction } from "../../../../actions/IeltsActions/learningManadmentAction";
import { ieltsCourseManagmentQuestionBankCreateAction } from "../../../../actions/IeltsActions/courseManagmentAction";
import { successTrueMsgAction } from "../../../../actions/globalAction";
import Swal from "sweetalert2";

function QuestionBankAddNewForm({ toggle }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({});

  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [uploadedQuestionBank, setUploadedQuestionBank] = useState("");
  const [err, setErr] = useState({
    title: "",
    category: "",
    uploadedQuestionBank: "",
    all: "",
  });

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = (event) => {
    const files = event.target.files;
    setSelectedFiles(Array.from(files));
  };

  const handleDelete = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };

  // Category List

  let { ieltsCategoryFindSuccess, ieltsCategoryFinderror } = useSelector(
    (state) => {
      return state.ieltsCategoryList;
    }
  );
  useEffect(() => {
    dispatch(ieltsCategoryFindAction("topicsAdd"));
  }, [dispatch]);

  useEffect(() => {
    if (ieltsCategoryFindSuccess) {
      setCategoryList(ieltsCategoryFindSuccess.data);
    }
  }, [ieltsCategoryFindSuccess]);

  // Success message

  let { successAlertMsgSuccess } = useSelector((state) => {
    return state.successTrueMsg;
  });

  let {
    ieltsCourseManagmentQuestionBankCreateSuccess,
    ieltsCourseManagmentQuestionBankCreateerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentQuestionBankCreate;
  });

  useEffect(() => {
    if (
      successAlertMsgSuccess &&
      ieltsCourseManagmentQuestionBankCreateSuccess?.status == true
    ) {
      Swal.fire("Created", "Question bank created successfully.", "success");
      dispatch(successTrueMsgAction(false));
    }
    if (
      successAlertMsgSuccess &&
      ieltsCourseManagmentQuestionBankCreateSuccess?.status == false
    ) {
      Swal.fire("Error", "Question bank not created.", "warning");
      dispatch(successTrueMsgAction(false));
    }
  }, [ieltsCourseManagmentQuestionBankCreateSuccess, successAlertMsgSuccess]);

  // Handle function for adding QuestionBank

  const handleAddNewButton = () => {
    let isValid = true;
    const currentErr = { ...err };
    if (!category) {
      currentErr.category = "Enter category name";
      isValid = false;
    }
    if (!title) {
      currentErr.title = "Enter title";
      isValid = false;
    }
    if (!uploadedQuestionBank) {
      currentErr.uploadedQuestionBank = "Upload question bank pdf";
      isValid = false;
    }
    setErr(currentErr);
    if (!isValid) {
      return;
    }
    const formData = new FormData();
    formData.append("title", title);
    formData.append("category", category);
    formData.append("uploadQuestionBank", uploadedQuestionBank);
    dispatch(ieltsCourseManagmentQuestionBankCreateAction(formData));
    dispatch(successTrueMsgAction(true));
    setTitle("");
    setCategory("");
    setUploadedQuestionBank("");
  };

  
  return (
    <MainContainer active={toggle}>
      <InfoHeader headTitle="Question Bank" url="/IELTS" />

      <div style={{ marginTop: "30px" }}>
        <Grid
          item
          lg={4}
          xs={12}
          sx={{
            "& .input-group": {
              mb: "44px",
              mt: "0",
            },
          }}
        >
          <InputField
            label="Title"
            handleChange={(e) => {
              {
                setTitle(e.target.value);
                setErr({ title: "" });
              }
            }}
            value={title}
            widthSize="546px"
            required
            paramses
            InputType="text"
            dispcriptionHeight
          />

          {err.title ? (
            <Typography
              sx={{
                mb: "44px",
                mt: "-34px",
                color: "red",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              {err.title}
            </Typography>
          ) : (
            ""
          )}
        </Grid>

        <Grid
          item
          lg={4}
          xs={12}
          sx={{
            "& .MuiFormControl-root": {
              maxWidth: "558px",
            },
          }}
        >
          <SelectInputField
            mapValue={categoryList}
            label="Select Category"
            handleSelectChange={(e) => {
              setCategory(e.target.value);
              setErr({ category: "" });
            }}
            widthSize="558px"
            value={category}
            mapMethod="ieltsCategory"
          />
          {err.category ? (
            <Typography
              sx={{
                mb: "44px",
                // mt: "-34px",
                color: "red",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              {err.category}
            </Typography>
          ) : (
            ""
          )}
        </Grid>

        <Grid
          item
          lg={4}
          xs={12}
          sx={{
            mt: "32px",
          }}
        >
          {!uploadedQuestionBank ? (
            <Box>
              <Typography
                sx={{
                  color: "#05050F",
                  fontSize: "16px",
                  lineHeight: "20px",
                  mb: "23px",
                }}
              >
                Upload File
              </Typography>
              <FormLabel
                sx={{
                  boxSizing: "border-box",
                  width: "100%",
                  maxWidth: "558px",
                  height: "46px",
                  border: "1px solid #C4C4C4",
                  display: "flex",
                  alignItems: "center",
                  pl: "14px",
                  pr: "8px",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "16px",
                    lineHeight: "24px",
                    color: formData.logoFile ? "#05050F" : "#ACB1C6",
                    textAlign: "left",
                    width: "100%",
                  }}
                >
                  Choose File
                </Typography>
                <input
                  type="file"
                  hidden
                  name="logoFile"
                  multiple
                  onChange={(e) => {
                    setUploadedQuestionBank(e.target.files[0]);
                    setErr({ uploadedQuestionBank: "" });
                  }}
                  accept=".pdf"
                />
                <Box
                  sx={{
                    cursor: "pointer",
                    padding: "4px 18px",
                    background: "#EBF2FD",
                    color: "#1E88E5",
                    fontWeight: 600,
                    fontSize: "12px",
                  }}
                >
                  Browse
                </Box>
              </FormLabel>
            </Box>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(4,234px)",
                padding: "30px 20px",
                background: "#F5F5F5",
                gap: "20px",
              }}
            >
              <Box>
                <TopicUploadComponent
                  type="pdf"
                  title={title}
                  handleClick={() => setUploadedQuestionBank("")}
                />
              </Box>
            </Box>
          )}

          {err.uploadedQuestionBank ? (
            <Typography
              sx={{
                mb: "44px",
                // mt: "-34px",
                color: "red",
                fontWeight: 400,
                fontSize: "12px",
              }}
            >
              {err.uploadedQuestionBank}
            </Typography>
          ) : (
            ""
          )}
        </Grid>

        <Box
          sx={{
            mt: "44px",
          }}
        >
          <SubmitButton
            title="Add New"
            submit=""
            widthSize="123px"
            heightSize="38px"
            type="click"
            handleSubmit={handleAddNewButton}
          />
        </Box>
      </div>
    </MainContainer>
  );
}

export default QuestionBankAddNewForm;
